import React from "react";

import { Button } from "aible";

import AibleStep from "containers/CreateWizard/AibleStep";
import Slider from "components/Inputs/Slider/Slider";

import styles from "./style.module.css";

export default class ChooseProcessLimit extends React.PureComponent {
  state = {
    showSlider: true
  };

  handleNoConstraints() {
    const { updateProcessLimit, total } = this.props;
    const { showSlider } = this.state;

    updateProcessLimit(total);
    return this.setState({ showSlider: !showSlider });
  }

  render() {
    const { id, total, processLimit, trueAction, options, targeted, isShow, timePeriod, updateProcessLimit } =
      this.props;
    const { showSlider } = this.state;

    if (processLimit === undefined) {
      return <div />;
    }

    const isLocked = options && options["lock"];

    return (
      <div className={styles.sliders}>
        <AibleStep
          id={id}
          message={
            "What is the maximum number of transactions" +
            (trueAction !== undefined && trueAction !== "" ? " (" + trueAction + ") " : " ") +
            "you will be able to process?"
          }
          secondaryMessage={
            "(Hint: You are currently processing " +
            targeted +
            " transactions" +
            (timePeriod ? " per " + timePeriod + ")" : "") +
            ". If you have a capacity constraint, I will adjust certain models and present the best AI for your capacity. "
          }
          isBreak={true}
          childStyle={{ flexDirection: "column", alignItems: "center" }}
          bId="processLimit"
        >
          {showSlider && (
            <div style={{ width: "100%" }} id="processSlider">
              <div className={styles.slideMsg}>{"My new processing capacity is: "}</div>
              <Slider
                min={0}
                max={total}
                value={processLimit}
                inputType={"int"}
                onChange={(val) => updateProcessLimit(val)}
                marks={{ [targeted]: "Current" }}
                className={styles.sliderHolder}
                endLabel={timePeriod ? "Transactions per " + timePeriod : "Transactions"}
                isWideLabel
                isLocked={isLocked}
                style={{ paddingTop: "0px" }}
              />
            </div>
          )}
          {isLocked !== true && (
            <div className={styles.pButton}>
              <Button type="secondary" onClick={() => this.handleNoConstraints()}>
                {showSlider ? "I have no processing constraints" : "I have processing constraints"}
              </Button>
            </div>
          )}
        </AibleStep>
      </div>
    );
  }
}
